// extracted by mini-css-extract-plugin
module.exports = {"label":"MessageLimitLabel_label__BpLjA"};